module.exports = __webpack_public_path__ + "img/slovakia.fdc13ec1.svg";